import { Observable } from 'rxjs';
export function observeMutations(target, options) {
    return new Observable((subscriber) => {
        const observer = new MutationObserver((mutations) => {
            subscriber.next(mutations);
        });
        observer.observe(target, options);
        return () => {
            observer.disconnect();
        };
    });
}
//# sourceMappingURL=observe-mutations.js.map